<template>
    <div class="qksm qksm10">
        <h4>十、财政拨款支出情况说明</h4>
        <div class="nogap">
            <p><b>（一）财政拨款支出总体情况。</b></p>
            <p>
                2020年度财政拨款支出{{isMoney(T10.总计)}}万元，占本年支出合计的{{calcRatio(T10.总计,T3.总计)}}。
                <span class="hide_pdf">
                    （上年决算数<reason type="money" classname="qksm money nullable" name="财政拨款支出去年" v-model:value="T10.总计_last"></reason>万元）
                </span>
                较上年{{growthValueText(T10.总计,T10.总计_last)}}万元，{{growthRatioText(T10.总计,T10.总计_last)}}。
                主要原因是<reason type="textarea" classname="qksm widest" name="财政拨款支出原因" v-model:value="qksm['财政拨款支出原因']"></reason>
            </p>
        </div>
        <div id="myChart10" class="echart" v-if="!isPdf && $parent.isData"></div>
        <div id="myChart10" class="echart" v-if="isPdf"></div>
        <div class="nogap">
            <p><b>（二）财政拨款支出结构情况。</b></p>
            <p>
                2020年度财政拨款支出主要用于以下方面：
                <span v-for="(item,idx) in T10.items">
                    {{item.name}}（类）{{isMoney(item.value)}}万元，占{{getPercentValue(T10.items.map(e=>e.value), idx, 2)}}{{idx==T10.items.length-1?'。':'；'}}
                </span>
            </p>

        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm10",
        props: {
            T3: {
                type: Object,
                default: "",
            },
            T10: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        data() {
            var qksm = this.$store.state.divData.qksm
            if (qksm['财政拨款支出去年'])
                this.T10['总计_last'] = qksm['财政拨款支出去年'];
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm
            }
        },
        computed: {
            总计_last() {
                return this.isMoney(this.T10.总计_last)
            }
        },
        watch: {
            总计_last() {
                this.$parent.isChart()
            }
        },
    };
</script>
